import { useState, useEffect } from "react";
import "@/App.css";
import { translations } from "./data/translations";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import ProductCatalogue from "./components/ProductCatalogue";
import QualityControl from "./components/QualityControl";
import WhyPartner from "./components/WhyPartner";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  const [lang, setLang] = useState("en");
  const t = translations[lang];

  useEffect(() => {
    document.title = t.seo.title;
    document.documentElement.lang = lang === "en" ? "en" : "zh-CN";
  }, [lang, t.seo.title]);

  return (
    <div className="App font-body">
      <a
        href="#main-content"
        className="sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-brand-blue focus:text-white focus:rounded-md focus:w-auto focus:h-auto focus:m-0 focus:overflow-visible focus:whitespace-normal focus:[clip:auto]"
      >
        Skip to main content
      </a>
      <header role="banner">
        <Navbar lang={lang} setLang={setLang} />
      </header>
      <main id="main-content" role="main">
        <Hero t={t} lang={lang} />
        <About t={t} />
        <ProductCatalogue t={t} lang={lang} />
        <QualityControl t={t} />
        <WhyPartner t={t} />
        <Contact t={t} />
      </main>
      <Footer t={t} />
    </div>
  );
}

export default App;
